type TxtWithBckContainerProps = {
   bckClr?: string
   clr?: string
   width?: string
   height?: string
   children: React.ReactNode
   padding?: string
   noBorder?: boolean
   margin?: string
   borderColor?: string
   borderWidth?: string
}
export default function TxtWithBckContainer(props: TxtWithBckContainerProps) {
   const {
      bckClr,
      clr,
      width,
      height,
      children,
      padding,
      noBorder,
      margin,
      borderColor,
      borderWidth,
   } = props
   const style = {
      background: bckClr,
      color: clr,
      padding: padding ? padding : '15px',
      width: width,
      height: height,
      border: noBorder ? 'none' : '2px solid white',
      borderRadius: 12,
      margin: margin ? margin : '15px 0',
      borderColor: borderColor ? borderColor : 'white',
      borderWidth: borderWidth && borderWidth,
   }
   return (
      <div style={style} className='flex center'>
         {children}
      </div>
   )
}
